import * as React from "react";
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";

export function ArchivedPage() {
  const wfStatus: TradeStatusEnum[] = [];
  const wfPhases: TradePhaseEnum[] = [];
  const cardTitle = "Operações Arquivadas";

  return <WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} showArchivedTrades={true} />;
}
export default ArchivedPage;



// WEBPACK FOOTER //
// ./src/pages/monitor/archived/Archived.page.tsx